import React, { createContext, useContext } from 'react';

const MapPreviewContext = createContext({
  isPreview: false,
  focusSheet: () => {},
});

export function MapPreviewProvider({ isPreview = false, focusSheet, children }) {
  return (
    <MapPreviewContext.Provider
      value={{
        isPreview: Boolean(isPreview),
        focusSheet: typeof focusSheet === 'function' ? focusSheet : () => {},
      }}
    >
      {children}
    </MapPreviewContext.Provider>
  );
}

export function useMapPreview() {
  return useContext(MapPreviewContext);
}
